import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { iconShape } from '../../../../../shared/types';

const TabsControl = ({ config }) => (
  <TabsList className="mb-8">
    {config.map(({ icon: Icon, label, value }) => (
      <TabsTrigger key={value} value={value}>
        <FontAwesomeIcon icon={Icon} />
        <span>{label}</span>
      </TabsTrigger>
    ))}
  </TabsList>
);

TabsControl.propTypes = {
  config: PropTypes.arrayOf(
    PropTypes.shape({
      icon: iconShape.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TabsControl;
